import React from "react";
import PropTypes from "prop-types";
import { AuthContext } from "react-oidc-context";

const mockEmail = process.env.REACT_APP_MOCK_USER_EMAIL || "dev@localhost.com";

const mockAuthValue = {
  isAuthenticated: true,
  isLoading: false,
  error: undefined,
  activeNavigator: undefined,
  user: {
    profile: {
      sub: mockEmail,
      email: mockEmail,
      name: mockEmail,
    },
    access_token: "mock-access-token",
    expired: false,
  },
  settings: {},
  events: {
    addUserLoaded: () => {},
    removeUserLoaded: () => {},
    addUserUnloaded: () => {},
    removeUserUnloaded: () => {},
    addSilentRenewError: () => {},
    removeSilentRenewError: () => {},
    addUserSignedOut: () => {},
    removeUserSignedOut: () => {},
    addUserSessionChanged: () => {},
    removeUserSessionChanged: () => {},
    addAccessTokenExpiring: () => {},
    removeAccessTokenExpiring: () => {},
    addAccessTokenExpired: () => {},
    removeAccessTokenExpired: () => {},
  },
  signinRedirect: () => Promise.resolve(),
  signinSilent: () => Promise.resolve(null),
  signinPopup: () => Promise.resolve(null),
  signinResourceOwnerCredentials: () => Promise.resolve(null),
  signoutRedirect: () => Promise.resolve(),
  signoutPopup: () => Promise.resolve(),
  signoutSilent: () => Promise.resolve(),
  removeUser: () => Promise.resolve(),
  clearStaleState: () => Promise.resolve(),
  querySessionStatus: () => Promise.resolve(null),
  revokeTokens: () => Promise.resolve(),
  startSilentRenew: () => {},
  stopSilentRenew: () => {},
};

MockAuthProvider.propTypes = {
  children: PropTypes.node,
};

export function MockAuthProvider({ children }) {
  return <AuthContext.Provider value={mockAuthValue}>{children}</AuthContext.Provider>;
}
